"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerComponents = void 0;
const lodash_1 = require("lodash");
/**
 * @example
 * registerComponents(
 *    require.context(
 *      './components', true, // is deep
 *      /[A-Z]\w+\.(vue|js|ts)$/
 *    ), Vue
 * )
 *
 * @param context - Require context
 * @param Vue - Vue instance
 */
const registerComponents = (context, Vue) => {
    context.keys().forEach((filename) => {
        const component = context(filename).default || context(filename);
        const componentName = !(0, lodash_1.isFunction)(component)
            ? component.name : (0, lodash_1.upperFirst)((0, lodash_1.camelCase)((filename.replace(/^\.\/(.*)\.\w+$/, '$1'))
            .split('/').pop()));
        Vue.component(componentName, component);
    });
};
exports.registerComponents = registerComponents;
